define(['jquery',
        'core/urls',
        'components/datatable',
        'components/daterangepicker',
        'core/formatting',
        'components/dropdown',
        'components/fake-progress',
    ],
    function($, urls, datatable, drp, formatting, DD, FakeProgress) {

        let currentScoreType = "csat";
        let peersData = {};
        let renderedTable = null;
        let loaderElement = document.querySelector(".marketing-loader");
        let progressBar = new FakeProgress(
            document.querySelector(".marketing-loader .loader-bar-wrap-bar")
        );

        let columns = {
            csat: [
                {
                    title: "Rank",
                    width: "60px",
                    className: "column-index",
                    data: "rank",
                    render: {
                        display: function(data) {
                            return `<div class="ranking">${data}</div>`
                        }
                    }
                },
                {
                    title: "Company",
                    width: "240px",
                    className: "column-company-name",
                    data: "name",
                    render: $.fn.dataTable.render.text()
                },
                {
                    title: "Net CSAT Score",
                    className: "column-net-csat-score",
                    data: "score",
                    render: {
                        display: formatting.asNetCsatScore
                    }
                },
                {
                    title: "Response Rate",
                    className: "column-net-response-rate",
                    data: "response_rate",
                    render: {
                        display: formatting.asResponseRate
                    }
                },
                {
                    title: "Reviews",
                    className: "column-net-total-reactions",
                    data: "total_reactions",
                    render: {
                        display: formatting.asReviewCount
                    }
                },
                {
                    title: "Positive",
                    className: "percentage-and-total column-net-positive",
                    data: "reactions_positive",
                    render: {
                        _: function(data, type, row) {
                            return formatting.asPercentage(formatting.cleanPercentageFraction(data, row.total_reactions));
                        },
                        display: function(data, type, row) {
                            return buildReactionRateHtml(data, row.total_reactions);
                        }
                    }
                },
                {
                    title: "Neutral",
                    className: "percentage-and-total column-net-neutral",
                    data: "reactions_neutral",
                    render: {
                        _: function(data, type, row) {
                            return formatting.asPercentage(formatting.cleanPercentageFraction(data, row.total_reactions));
                        },
                        display: function(data, type, row) {
                            return buildReactionRateHtml(data, row.total_reactions);
                        }
                    }
                },
                {
                    title: "Negative",
                    className: "percentage-and-total column-net-negative",
                    data: "reactions_negative",
                    render: {
                        _: function(data, type, row) {
                            return formatting.asPercentage(formatting.cleanPercentageFraction(data, row.total_reactions));
                        },
                        display: function(data, type, row) {
                            return buildReactionRateHtml(data, row.total_reactions);
                        }
                    }
                }
            ],
            nps: [
                {
                    title: "Rank",
                    width: "60px",
                    className: "column-index",
                    data: "rank",
                    render: {
                        display: function(data) {
                            return `<div class="ranking">${data}</div>`
                        }
                    }
                },
                {
                    title: "Company",
                    width: "240px",
                    className: "column-company-name",
                    data: "company_name",
                    render: $.fn.dataTable.render.text()
                },
                {
                    title: "Responses",
                    data: "total",
                    render: {
                        display: function(data) {
                            return data;
                        }
                    }
                },
                {
                    title: "Response Rate",
                    data: "response_rate",
                    render: {
                        display: function(data) {
                            return data;
                        }
                    }
                },
                {
                    title: "Positive",
                    className: "percentage-and-total column-net-positive",
                    data: "promoters",
                    render: {
                        _: function(data, type, row) {
                            return formatting.asPercentage(formatting.cleanPercentageFraction(data, row.total));
                        },
                        display: function(data, type, row) {
                            return buildReactionRateHtml(data, row.total);
                        }
                    }
                },
                {
                    title: "Neutral",
                    className: "percentage-and-total column-net-neutral",
                    data: "passives",
                    render: {
                        _: function(data, type, row) {
                            return formatting.asPercentage(formatting.cleanPercentageFraction(data, row.total));
                        },
                        display: function(data, type, row) {
                            return buildReactionRateHtml(data, row.total);
                        }
                    }
                },
                {
                    title: "Negative",
                    className: "percentage-and-total column-net-negative",
                    data: "detractors",
                    render: {
                        _: function(data, type, row) {
                            return formatting.asPercentage(formatting.cleanPercentageFraction(data, row.total));
                        },
                        display: function(data, type, row) {
                            return buildReactionRateHtml(data, row.total);
                        }
                    }
                },
            ]
        }

        function buildReactionRateHtml(noOfReactions, totalReactions) {
            let percentage = formatting.asPercentage(formatting.cleanPercentageFraction(noOfReactions, totalReactions));
            let total = formatting.asReviewCount(noOfReactions);
            return `<div class="review-count">
                        <div class="total">${total}</div>
                        <div class="percentage">(${percentage})</div>
                    </div>
                    `;
        }

        async function getPeersData() {
            let peer_group = $('#csat-report-type').val();
            let url = urls['csat:peer-leaderboard-data'](drp.getStartDate().format('YYYY-MM-DD'), drp.getEndDate().format('YYYY-MM-DD'), peer_group, currentScoreType);
            
            loaderElement.classList.remove("disabled");
            progressBar.startLoading(15);

            await fetch(url)
            .then((response) => response.json())
            .then((data) => {
                peersData = data;

                if(!renderedTable) {
                    buildDataTable();
                } else {
                    renderedTable.clear().draw();
                    renderedTable.rows.add(peersData); // Add new data
                    renderedTable.columns.adjust().draw();
                }

                loaderElement.classList.add("disabled");
                progressBar.loadFinish();
            });
        }

        function buildDataTable() {
            renderedTable = datatable.create('#peers', {
                columns: columns[currentScoreType],
                data: peersData,
                ajax: null,
                order: [[0, "asc"]],
                buttons: [],
                searching: false,
                paging: false,
                info: false,
                processing: false,
                language: {
                    emptyTable: '<div class="no-data lead text-center alert alert-primary col-lg-6 mr-auto ml-auto" role="alert">There is no data to be displayed for the given time period.</div>',
                    zeroRecords: '<div class="no-data lead text-center alert alert-primary col-lg-6 mr-auto ml-auto" role="alert">There is no data to be displayed for the given time period.</div>'
                },
                createdRow: function(row, data, dataIndex) {
                    $(row).find('td:first-child').attr('data-value', (data.rank > 10 ? '10+' : data.rank));
                    if (data.current_account) {
                        $(row).addClass('current-user');
                    }
                }
            });
        }

        return {
            init: function() {
                drp.create({}, getPeersData);
                drp.loadFromBrowserStorage('csat-peer-leaderboard');

                getPeersData();

                let peerGroupForm = document.querySelector(".group-selector")
                if(peerGroupForm) {
                    DD(peerGroupForm, (value) => {
                        getPeersData();
                    });
                }

                let resultTypeWrapper = document.querySelector(".result-type-selector")
                DD(resultTypeWrapper, (value) => {
                    currentScoreType = value;
                    renderedTable.destroy();
                    $("#peers").empty();
                    renderedTable = null;
                    getPeersData();
                });
                
            }
        };
    }
);
